/**
 * Borrador continuo del carrito (cortes de luz / cierre de pestaña).
 */

const BORRADOR_KEY = 'pos_borrador_pedido';
const BORRADOR_BAK_KEY = 'pos_borrador_pedido_bak';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
const SAVE_DEBOUNCE_MS = 350;
const SAVE_WATCHDOG_MS = 2000;

function buildBorradorPedido(win) {
	const carrito = win.carrito || [];
	const descuentoActual = win.descuentoActual || { tipo: 'porcentaje', valor: 0, activo: false };
	return {
		items: carrito.slice(0),
		mesa: win.mesaSeleccionada || null,
		cliente: win.clienteSeleccionado || null,
		tipo_servicio: win.modoServicioSeleccionado || 'comer',
		delivery_fee: typeof win.getDeliveryFeeUsd === 'function' ? win.getDeliveryFeeUsd() : 0,
		repartidor: typeof win.getRepartidorPedido === 'function' ? win.getRepartidorPedido() : null,
		descuento: {
			tipo: descuentoActual.tipo,
			valor: descuentoActual.valor,
			activo: !!descuentoActual.activo,
		},
		numero: '#',
		fecha: new Date().toISOString(),
		savedAt: Date.now(),
	};
}

function writeDraftStorage(win, raw) {
	try {
		win.localStorage.setItem(BORRADOR_KEY, raw);
	} catch (e) {
		return false;
	}
	try {
		win.localStorage.setItem(BORRADOR_BAK_KEY, raw);
	} catch (e2) {
		/* ignore */
	}
	return true;
}

function clearDraftStorage(win) {
	try {
		win.localStorage.removeItem(BORRADOR_KEY);
		win.localStorage.removeItem(BORRADOR_BAK_KEY);
	} catch (e) {
		/* ignore */
	}
}

function parseDraft(raw) {
	if (!raw) return null;
	try {
		const b = JSON.parse(raw);
		if (!b || !Array.isArray(b.items) || !b.items.length) return null;
		const ts = Date.parse(b.fecha || '') || parseInt(b.savedAt, 10) || 0;
		if (ts && Date.now() - ts > MAX_AGE_MS) return null;
		return b;
	} catch (e) {
		return null;
	}
}

function readDraftStorage(win) {
	let primary = null;
	let bak = null;
	try {
		primary = parseDraft(win.localStorage.getItem(BORRADOR_KEY));
	} catch (e) {
		primary = null;
	}
	try {
		bak = parseDraft(win.localStorage.getItem(BORRADOR_BAK_KEY));
	} catch (e2) {
		bak = null;
	}
	if (primary && bak) {
		const pa = parseInt(primary.savedAt, 10) || Date.parse(primary.fecha || '') || 0;
		const pb = parseInt(bak.savedAt, 10) || Date.parse(bak.fecha || '') || 0;
		return pb > pa ? bak : primary;
	}
	return primary || bak;
}

function persistDraftNow(win) {
	const carrito = win.carrito || [];
	if (!carrito.length) {
		clearDraftStorage(win);
		return true;
	}
	try {
		return writeDraftStorage(win, JSON.stringify(buildBorradorPedido(win)));
	} catch (e) {
		console.warn('No se pudo guardar borrador:', e);
		return false;
	}
}

function initOrderDraftLifecycle(win, $) {
	if (win._posknOrderDraftBound) return;
	win._posknOrderDraftBound = true;

	let saveTimer = null;
	win._posknScheduleDraftSave = function posknScheduleDraftSave() {
		if (saveTimer) {
			win.clearTimeout(saveTimer);
		}
		saveTimer = win.setTimeout(() => {
			saveTimer = null;
			persistDraftNow(win);
		}, SAVE_DEBOUNCE_MS);
	};

	const flush = () => persistDraftNow(win);
	$(window).on('pagehide', flush);
	if (!win.POSKN_IS_DESKTOP) {
		$(window).on('beforeunload', flush);
	}
	win.addEventListener('pagehide', flush);
	document.addEventListener('visibilitychange', () => {
		if (document.visibilityState === 'hidden') {
			flush();
		}
	});
	win.setInterval(() => {
		const carrito = win.carrito || [];
		if (carrito.length) {
			persistDraftNow(win);
		}
	}, SAVE_WATCHDOG_MS);

	$(() => {
		const current = win.carrito || [];
		if (current.length) {
			return;
		}
		const b = readDraftStorage(win);
		if (!b) {
			return;
		}
		win.setTimeout(() => {
			if ((win.carrito || []).length) {
				return;
			}
			try {
				if (win.localStorage.getItem('pos_pedido_enviando')) {
					if (typeof win.borrarBorradorPedido === 'function') {
						win.borrarBorradorPedido();
					}
					return;
				}
			} catch (eEnv) {
				/* ignore */
			}
			if (typeof win.recuperarBorradorPedido === 'function') {
				win.recuperarBorradorPedido();
			}
		}, 400);
	});
}

export function attachOrderDraftGlobals(win, $) {
	initOrderDraftLifecycle(win, $);

	win.guardarBorradorPedido = function guardarBorradorPedido() {
		if (typeof win._posknScheduleDraftSave === 'function') {
			win._posknScheduleDraftSave();
			return true;
		}
		return persistDraftNow(win);
	};

	win.borrarBorradorPedido = function borrarBorradorPedido() {
		clearDraftStorage(win);
		return true;
	};

	win.recuperarBorradorPedido = function recuperarBorradorPedido() {
		try {
			try {
				if (win.localStorage.getItem('pos_pedido_enviando')) {
					clearDraftStorage(win);
					return false;
				}
			} catch (eEnv) {
				/* ignore */
			}
			const b = readDraftStorage(win);
			if (!b || !b.items || !b.items.length) return false;

			const carrito = win.carrito || (win.carrito = []);
			carrito.splice(0, carrito.length, ...b.items);

			win.mesaSeleccionada = b.mesa || null;
			win.clienteSeleccionado = b.cliente || null;

			if (b.tipo_servicio && typeof win.seleccionarTipoServicio === 'function') {
				win.seleccionarTipoServicio(b.tipo_servicio);
			}
			if (b.delivery_fee && parseFloat(b.delivery_fee) > 0) {
				$('#delivery-fee-input').val(parseFloat(b.delivery_fee).toFixed(2));
			}
			if (b.repartidor && b.repartidor.id) {
				win._posknRepartidorDraftId = b.repartidor.id;
				$('#poskn-repartidor-select').val(String(b.repartidor.id));
			}

			if (b.descuento) {
				win.descuentoActual = {
					tipo: b.descuento.tipo || 'porcentaje',
					valor: parseFloat(b.descuento.valor) || 0,
					activo: !!b.descuento.activo,
				};
			}

			const d = win.descuentoActual || { tipo: 'porcentaje', valor: 0, activo: false };
			$('#descuento-tipo').val(d.tipo);
			$('#descuento-valor').val(d.valor);
			if (d.activo) {
				$('#descuento-activo').show();
			} else {
				$('#descuento-activo').hide();
			}

			if (win.mesaSeleccionada) {
				$('#mesa-badge').text(win.mesaSeleccionada.numero || '').show();
				$('#mesa-seleccionada-compacto').show();
				$('#mesa-indicador-carrito').show();
				$('#mesa-numero-carrito').text(win.mesaSeleccionada.numero || '');
			} else {
				$('#mesa-badge').hide();
				$('#mesa-seleccionada-compacto').hide();
				$('#mesa-indicador-carrito').hide();
			}

			if (win.clienteSeleccionado) {
				if (typeof win.mostrarClienteSeleccionado === 'function') {
					win.mostrarClienteSeleccionado();
				} else {
					$('#cliente-buscar').val(win.clienteSeleccionado.nombre || '');
					$('#cliente-badge')
						.text(String(win.clienteSeleccionado.nombre || '').substring(0, 10))
						.show();
					$('#cliente-seleccionado-compacto').show();
					$('#cliente-seleccionado').show();
				}
			} else if (typeof win.resetClienteSeleccion === 'function') {
				win.resetClienteSeleccion(true);
			} else {
				$('#cliente-seleccionado').hide();
				$('#cliente-badge').hide();
				$('#cliente-seleccionado-compacto').hide();
				$('#cliente-buscar').val('');
			}

			win.actualizarCarrito();
			if (typeof win.actualizarBadgesDescuento === 'function') win.actualizarBadgesDescuento();
			if (typeof win.actualizarBotonesMesa === 'function') win.actualizarBotonesMesa();
			win.mostrarNotificacion(
				'Pedido recuperado (corte o cierre). Revisa y cobra cuando quieras.',
				'success',
			);
			return true;
		} catch (e) {
			console.warn('Error al recuperar borrador:', e);
			return false;
		}
	};

	win.limpiarCarrito = function limpiarCarrito() {
		const carrito = win.carrito || (win.carrito = []);
		if (!carrito.length) return;

		const vaciar = () => {
			carrito.splice(0, carrito.length);
			if (typeof win.borrarBorradorPedido === 'function') win.borrarBorradorPedido();
			win.actualizarCarrito();
			win.mostrarNotificacion('Carrito limpiado', 'success');
		};

		if (win.posknCodigoLimpiar && String(win.posknCodigoLimpiar).trim().length > 0) {
			win.posknPedirCodigo('Código para limpiar pedido').then((codigo) => {
				if (codigo === false) return;
				vaciar();
			});
			return;
		}

		if (!confirm('¿Está seguro de limpiar el carrito?')) return;
		vaciar();
	};

	win.nuevoPedido = function nuevoPedido() {
		const carrito = win.carrito || (win.carrito = []);
		carrito.splice(0, carrito.length);

		win.clienteSeleccionado = null;
		win.mesaSeleccionada = null;
		win.pedidoMesaAbierto = null;

		$('#mesa-badge').hide();
		$('#mesa-seleccionada-compacto').hide();
		$('#mesa-indicador-carrito').hide();

		win.descuentoActual = { tipo: 'porcentaje', valor: 0, activo: false };
		$('#descuento-tipo').val('porcentaje');
		$('#descuento-valor').val('');
		$('#descuento-activo').hide();

		$('#cliente-seleccionado').hide();
		$('#cliente-badge').hide();
		$('#cliente-seleccionado-compacto').hide();
		$('#cliente-buscar').val('');

		if (typeof win.borrarBorradorPedido === 'function') win.borrarBorradorPedido();
		win.actualizarCarrito();
		if (typeof win.actualizarBadgesDescuento === 'function') win.actualizarBadgesDescuento();

		if (typeof win.cerrarModal === 'function') {
			win.cerrarModal('modal-exito');
		}

		win.posknCknCache = {};
		win.productosCargados = null;
		try {
			win.localStorage.removeItem('poskn_productos_cache');
			win.localStorage.removeItem('poskn_productos_timestamp');
		} catch (e) {
			console.warn('No se pudo limpiar cache:', e);
		}

		if (typeof win.actualizarBotonesMesa === 'function') win.actualizarBotonesMesa();

		console.log('✅ Nuevo pedido iniciado. Sistema listo sin recargar.');
		win.mostrarNotificacion('Sistema listo para nuevo pedido', 'success');
	};
}
